import React from 'react'
import useReduxState from 'src/hooks/useReduxState';
import HomePageContentTabsListing from './HomePageContentTabsListing';

export function HomePageContentTabs(props) {
const [selectedTab] = useReduxState('', 'searchContentTabParams')
  return (
        <HomePageContentTabsListing  selectedTab={selectedTab} {...props} />
  )
}
